import SimpleDialog from "@rio-cloud/rio-uikit/SimpleDialog";
import { useIntl } from "react-intl";
import { Scheduling } from "../../../../../models/schedule";

interface IOccurrenceVehicleScheduledServicesDialogProps {
  show: boolean;
  scheduling?: Scheduling | null;
  onClose: () => void;
}

const OccurrenceVehicleScheduledServicesDialog = (
  props: IOccurrenceVehicleScheduledServicesDialogProps
) => {
  const intl = useIntl();
  const { show, scheduling, onClose } = props;
  const hasObservations = !!(scheduling?.observation || scheduling?.comments);

  return (
    <SimpleDialog
      show={show}
      title={intl.formatMessage({ id: "intl-msg:schedulingSummary.scheduledServicesAndParts" })}
      bsSize="sm"
      onClose={onClose}
      content={
        <ul className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
          {scheduling?.checkup?.services?.map((service, index) => (
            <div key={index} className="padding-bottom-10">
              <p className="text-bold">{service.name}</p>
              {service.items?.map((item, itemIndex) => (
                <p key={itemIndex} className="padding-left-20">
                  - {item}
                </p>
              ))}
            </div>
          ))}

          {(scheduling?.otherServices?.length ?? 0) > 0 && (
            <div className="padding-bottom-10">
              <p className="text-bold">{intl.formatMessage({ id: "intl-msg:schedulingSummary.otherServices" })}</p>
              {scheduling?.otherServices?.map((service, index) => (
                <p key={index} className="padding-left-20">
                  - {service}
                </p>
              ))}
            </div>
          )}

          {(scheduling?.checkup?.parts?.length ?? 0) > 0 && (
            <div className="padding-bottom-10">
              <p className="text-bold">{intl.formatMessage({ id: "intl-msg:schedulingSummary.parts" })}</p>
              {scheduling?.checkup?.parts?.map((part, index) => (
                <p key={index} className="padding-left-20 py-2">
                  {part.qtd}x {part.description}
                  {part.code && (
                    <span className="text-color-status-resting"> - {intl.formatMessage({ id: "intl-msg:schedulingSummary.partCode" })}: {part.code}</span>
                  )}
                </p>
              ))}
            </div>
          )}

          {hasObservations && (
            <div className="padding-bottom-10">
              <p className="text-bold">{intl.formatMessage({ id: "intl-msg:schedulingSummary.observations" })}</p>
              <p className="padding-left-20">
                {scheduling?.observation || scheduling?.comments}
              </p>
            </div>
          )}
        </ul>
      }
    />
  );
};

export default OccurrenceVehicleScheduledServicesDialog;
